export default {
  __(str) {
    if (window.tom && window.tom.i18n && window.tom.i18n.__) {
      return window.tom.i18n.__(str);
    }
    return str;
  }
};
